import { makeStyles } from "@fluentui/react-components";
import { InteractionDirection } from "@/repository/models";
import { ellipsis } from "@/common/style/commonStyle";
import { DirectionArrow } from "./DirectionArrow";

const useStyles = makeStyles({
	container: {
		display: "inline-flex",
		alignItems: "center",
		gap: "2px",
		minWidth: 0,
		// Capped at the width of the line it sits on, which is what lets the text inside shrink.
		maxWidth: "100%",
	},
	// The text is its own box: a bare text node in a flex container is clipped, never ellipsised.
	text: {
		...ellipsis(),
	},
});

export interface SubHeaderWithDirectionProps {
	text: string;
	direction?: InteractionDirection;
}

// List-item second line with the call-direction arrow inline before the
// contact info.
export const SubHeaderWithDirection = (props: SubHeaderWithDirectionProps) => {
	const classes = useStyles();

	return (
		// List.tsx only sets a title for string subHeaders, so expose the
		// ellipsized contact info as a tooltip here.
		<span className={classes.container} title={props.text}>
			<DirectionArrow direction={props.direction} />
			<span className={classes.text}>{props.text}</span>
		</span>
	);
};
